import { gql, request, useMutation } from '~reactQuery';

import { useQueryClient } from 'react-query';

interface PutIncomesInput {
  businessDataId: number;
  incomes: string[];
}

interface PutIncomesResponse {
  putIncomes: {
    data: {
      id: number;
      income: string;
      createdAt: string;
      updatedAt: string;
      deleted: boolean;
      deletedAt: string;
      businessDataId: number;
    };
    messages: [string];
    isValid: boolean;
  };
}

export function usePutIncomesMutation() {
  const queryClient = useQueryClient();

  const mutation = gql`
    mutation PutIncomes($params: putIncomesInput!) {
      putIncomes(params: $params) {
        data {
          id
          income
          createdAt
          updatedAt
          deleted
          deletedAt
          businessDataId
        }
        messages
        isValid
      }
    }
  `;

  const fetch = async (params: PutIncomesInput) => {
    const response = await request<PutIncomesResponse>(mutation, {
      params,
    });

    return response.putIncomes;
  };

  return useMutation('PutIncomes', fetch, {
    onSettled: () => {
      queryClient.invalidateQueries(['getProcess']);
    },
  });
}
